import { IQueryClassDependency } from '@kurtosys/types/dependencies/IQueryClassDependency.js';
import { ITransformClassDependency } from '@kurtosys/types/dependencies/ITransformClassDependency.js';
import { IExecutionOptions, IQueryOptions } from '@kurtosys/types/query/index.js';
import { ITransformOptions } from '@kurtosys/types/query/transforms/ITransformOptions.js';

import { helpers } from '../../common/index.js';

export abstract class BaseTransform {
	constructor(
		public dependencies: IQueryClassDependency & ITransformClassDependency,
		public options: ITransformOptions,
		public translationHelper: helpers.TranslationHelper,
		public callStackLevel?: number,
	) {}
	abstract execute(queryResponse: any, queryOptions: IQueryOptions, executionOptions: IExecutionOptions): any;
}
